import React from 'react';
import cs from 'classnames';
import KEYS from '~/misc/keys';
import {connect} from 'react-redux';
import {videoChange} from '~/modules/modal/actions';

import css from './index.css';

class Video extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.videoCloseUI = (vid, show) => props.dispatch(videoChange(vid, show));
  }

  render() {
    // VID use to destrol component , hide use to init component and hide component;
    if (this.props.vid === 'destroy') {
      return null;
    }
    const showPop = Boolean(this.props.show);
    return (
      <div className={cs(css.videoWrap, (showPop ? css.show : css.hide))}>
        <div className={css.block} data-qa='videoPop'>
          <div className={css.Video}>
            {
              <iframe className={css.initIframe} src='https://www.youtube.com/embed/Jmgq8DlNWcw' />
            }
          </div>
          <span className={cs('video-close', css.closeButton)} onClick={this.close}>×</span>
        </div>
      </div>
    );
  }

  onKeyPress(e) {
    if (e.keyCode === KEYS.ESC) {
      this.close();
    }
  }

  close() {
    // destrol component;
    this.videoCloseUI('destroy', false);
    // update component and hide component;
    setTimeout(() => this.videoCloseUI('', false), 0);
  }
}

export default connect((state) => ({
  vid: state.modal.vid,
  show: state.modal.show,
})
)(Video);




// WEBPACK FOOTER //
// ./src/components/Video/index.js